import { StoreConfig, EntityStore, EntityState } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IProgramTemplate } from 'typings/doenkids/doenkids';

export interface IProgramTemplateBaseListState extends EntityState<IProgramTemplate> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'program-template-base-list' })
export class ProgramTemplateBaseListStore extends EntityStore<IProgramTemplateBaseListState, IProgramTemplate> {
  constructor() {
    super([]);
  }
}
